export interface INotesTypesFormDelegate {
    afterNotesTypeSaved(): void;
    cancelNotesType(): void;
}
